import React from 'react';
import { MainPage } from '../../components/MainPage';
import { PressRelease } from '../../../types/types';

const App = (props: { pressReleases: PressRelease[]; selectedYear: string }) => (
  <MainPage pressReleases={props.pressReleases} selectedYear={props.selectedYear} />
);

export default App;
